<template>
    <div>
        <month-chart
            :balance = "this.balance"
            :leverage = "this.leverage"
            :leverageMax = "this.leverageMax"
        ></month-chart>
        <week-chart
            :balance = "this.balance"
            :leverage = "this.leverage"
            :leverageMax = "this.leverageMax">
        </week-chart>
        <week-stat></week-stat>
    </div>
    
</template>
<script>
import MonthChart from "./sig-profitability-chart-month-left-widget";
import WeekChart from "./sig-profitability-chart-week-left-widget";
import WeeksStat from "./sig-profitability-weeks-stat-left-widget";
export default {
    props : {
        balance: {default:0},
        leverage: {default:0},
        leverageMax: {default:0}
    },
    components: {
        "month-chart":MonthChart,
        "week-chart":WeekChart,
        "week-stat":WeeksStat
    }
}
</script>

